import { Flex, Heading, Spinner } from '@chakra-ui/react'
import { FC } from 'react'

import AuthLayout from '@component/Layout/Auth'

const AuthLoading: FC = () => {
  return (
    <AuthLayout title="Recuperando dados">
      <Flex alignItems="center" justifyContent="center" flexDir="column">
        <Heading mb={6} size="xs" color="gray.500" fontWeight="400">
          Iniciando ambiente seguro para autenticação...
        </Heading>
        <Spinner color="yellow.400" />
      </Flex>
    </AuthLayout>
  )
}

export default AuthLoading
